export const ReportPageConstant = {
    OVERVIEW: 1,
    LOCATION: 2,
    OWNERSHIP: 3,
    INCOME: 4,
    FUTURE_PROJECTION: 5,
    RENT: 6,
    OWNERS_SALARY: 7,
    ADJUSTMENTS: 8,
    WEIGHTINGS: 9,
    PROJECTION: 10,
    ASSETS_LIABILITIES: 11,
    DIVERSIFICATION: 12,
    PERSONAL_GOODWILL: 13,
    BARRIERS_ENRTY: 14,
    RECURRING_REVENUE: 15,
    CONCLUSION: 16
}

export const PageNameConstant = {
    OVERVIEW: 'OVERVIEW',
    LOCATION: 'LOCATION',
    OWNERSHIP: 'OWNERSHIP',
    INCOME: 'INCOME',
    FUTURE_PROJECTION: 'FUTURE_PROJECTION',
    RENT: 'RENT',
    OWNERS_SALARY: 'OWNERS_SALARY',
    ADJUSTMENTS: 'ADJUSTMENTS',
    WEIGHTINGS: 'WEIGHTINGS',
    PROJECTION: 'PROJECTION',
    ASSETS_LIABILITIES: 'ASSETS_LIABILITIES',
    DIVERSIFICATION: 'DIVERSIFICATION',
    PERSONAL_GOODWILL: 'PERSONAL_GOODWILL',
    BARRIERS_ENTRY: 'BARRIERS_ENTRY',
    RECURRING_REVENUE: 'RECURRING_REVENUE',
    CONCLUSION: 'CONCLUSION',
    DASHBOARD: 'DASHBOARD',
    EXPRESS_VALUE: 'EXPRESS_VALUE',
    TRANSACTIONS_HISTORY: 'TRANSACTIONS_HISTORY',
    ACCOUNT_SETTING: 'ACCOUNT_SETTING',
    INTRODUCTION: 'INTRODUCTION',
    CHECKOUT: 'CHECKOUT',
    REPORT_VERSIONS: 'REPORT_VERSIONS',
    PRICING: 'PRICING'
}